export class SquarzFailure {
    static MAX_DISTANCE_IS_N = (n) => $localize `You jumped too far! The maximum size of a jump is ${n} step!`;
}
